import styled from 'styled-components';

interface Props {
  isOpen?: boolean;
  colorType?: string;
  fill?: string;
}

const ValueWrapper = styled.input`
  width: 100%;
  padding-left: 8px;
  padding-right: 32px;
  box-sizing: border-box;
  border-radius: 5px;
  line-height: 32px;
`;

const AutoCompleteIcon = styled.span<Props>`
  position: absolute;
  top: 0;
  right: 0;
  height: 32px;
  width: 32px;
  transition: all 150ms linear;
  transform: ${(props) => (props.isOpen ? 'rotate(0.5turn)' : 'none')};
  transform-origin: center;
  display: flex;
  svg {
    margin: auto;
  }
  ${ValueWrapper}:focus + & {
    color: ${(props) => props?.colorType || '0063cc'};
    fill: ${(props) => props?.fill || '0063cc'};
  }
`;

export const Input = styled(ValueWrapper)<Props>`
  transition: border-color 150ms linear;
  &:focus {
    border-color: #0063cc;
    outline: none;
    + ${AutoCompleteIcon} {
      color: ${(props) => props.color || '0063cc'};
      fill: ${(props) => props.fill || '0063cc'};
    }
  }
`;
